import Link from 'next/link';

import styles from './department-link.module.scss';

export interface MaybeLinkProps {
	route?: string;
	name: string;
}

export default function MaybeLink({ route, name }: MaybeLinkProps) {
	return (
		route ? (
			<Link className={styles.link} href={route} >{name}</Link>
		) : (
			<>{name}</>
		)
	);
}
